function e(o, r) {
  return e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, e(o, r);
}
export {
  e as default
};
